<div class="antialiased h-full">
  <empro-navigation viewport="large">
    <a routerLink="/customers" class="flex grow md:grow-0 basis-0">
      <empro-navigation-item
        icon="users"
        label="Kunden"
        routerLinkActive="active"
        viewport="large"
      />
    </a>
    <a class="flex grow md:grow-0 basis-0" (click)="onNewCustomerClicked()">
      <empro-navigation-item
        icon="plus"
        label="Neu"
        routerLinkActive="active"
        viewport="large"
      />
    </a>
    <a routerLink="/migration" class="flex grow md:grow-0 basis-0">
      <empro-navigation-item
        icon="rocket-launch"
        label="Migration"
        routerLinkActive="active"
        viewport="large"
      />
    </a>
    <a routerLink="/license" class="flex grow md:grow-0 basis-0">
      <empro-navigation-item
        icon="key"
        label="Lizenz"
        routerLinkActive="active"
        viewport="large"
      />
    </a>
    <hr
      class="mt-auto mb-4 w-[4.75rem] border-t border-solid border-gray-400 inline-block"
    />
    <empro-navigation-item
      icon="arrow-left-on-rectangle"
      label="Logout"
      class="mb-0 md:!mb-10"
      (click)="authService.logout()"
      (keydown.enter)="authService.logout()"
      viewport="large"
    />
  </empro-navigation>

  <main class="mt-14 md:mt-0 md:ml-48 relative">
    <div class="relative h-full p-4">
      <ng-content />
    </div>
  </main>
</div>
